import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';

export default function InitialLanguageRedirect({ target }) {
  useEffect(() => {
    sessionStorage.setItem('enkel_auto_lang_done', '1');
  }, [target]);
  return <Navigate to={target} replace />;
}